module.exports = __webpack_public_path__ + "media/application/images/svgs/pen-tool-32bc14ccd656dfa4f202574ea976e735.svg";